import axios from 'axios';
import { PROCESS_AUTOMATION_SERVICE_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

export const deployRepositories = async (repositories, token) => {
  try {
    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/multi-deployment/deployment`,
      repositories,
      {
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};
